import { render, staticRenderFns } from "./customLabel.vue?vue&type=template&id=0cdda266&scoped=true"
import script from "./customLabel.vue?vue&type=script&lang=js"
export * from "./customLabel.vue?vue&type=script&lang=js"
import style0 from "./customLabel.vue?vue&type=style&index=0&id=0cdda266&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdda266",
  null
  
)

export default component.exports